import React from 'react'
import abimg from '../../images/about.jpg'
import signature from '../../images/signature.png'
import { Link } from 'react-router-dom';

const About = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="about-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-4 col-12">
                        <div className="left-col">
                            <div className="section-title">
                                <div className="icon">
                                    <i className="fi flaticon-home-3"></i>
                                </div>
                                <span>About Schiff Law</span>
                                <h2>Where Experience Meets Understanding</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                <Link onClick={ClickHandler} to="/" className="more-about">Read More About us <i className="fi flaticon-next-1"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col col-lg-4 col-12">
                        <div className="mid-col">
                            <img src={abimg} alt="" />
                        </div>
                    </div>
                    <div className="col col-lg-4 col-12">
                        <div className="right-col">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <div className="quoter">
                                <h4>Michel Schiff</h4>
                                <span>Co-Founder</span>
                            </div>
                            {/* <div className="signature">
                                <img src={signature} alt="" />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;